export default {
  default_browser_tag: 'FoodAmigos - Tilaa verkossa',
  seo: {
    title: '{{name}} - tilaa ruokaa verkossa kaupungissa {{city}}',
    description: '{{name}} kaupungissa {{city}}. Virallinen menu. Säästä rahaa ja tilaa verkossa.',
  },
};
